export const getColumns = [
  {
    title: 'Operation',
    field: 'operationCode',
    headerStyle: { zIndex: 11 }
  },
  {
    title: 'Response Code',
    field: 'httpStatus',
    render: (rowData: any) => (rowData.httpStatus === 0 ? '' : rowData.httpStatus),

    headerStyle: { zIndex: 11 }
  },
  {
    title: 'Type',
    field: 'type',
    headerStyle: { zIndex: 11 }
  }
];

export default getColumns;
